module.exports = __webpack_public_path__ + "static/media/JO.a4fb222c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/JO.svg
// module id = 284
// module chunks = 0